import { createHlc, uuidv7 } from '@timato/shared';

const KEY = 'timato.deviceId';
export function deviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) { id = uuidv7(); localStorage.setItem(KEY, id); }
    return id;
  } catch { return 'ephemeral-device'; }
}
/** One HLC per page load; stamps every local write's updatedAt. */
export const hlc = createHlc(deviceId());
